module.exports = __webpack_public_path__ + "media/src/images/icons/notice/red-19c8b6e3f8e8039095533dc8ecdfd29d.svg";